export const comments_3399188 = {"data":{"data":[],"links":{}}}